var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileZip = function SvgIconFileZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.125 4.375v7.25a1 1 0 1 1-2 0v-7.5a1.75 1.75 0 0 1 1.75-1.75h9.75a1 1 0 0 1 .707.293l5.25 5.25a1 1 0 0 1 .293.707v3a1 1 0 1 1-2 0v-1.25h-5a1 1 0 0 1-1-1v-5zm9.75 4V5.039l3.336 3.336zM16.5 14.375a1 1 0 0 0-1 1v5.25a1 1 0 1 0 2 0v-.5h.5a2.875 2.875 0 1 0 0-5.75zm1.5 3.75h-.5v-1.75h.5a.875.875 0 1 1 0 1.75",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.375a1 1 0 0 1 1 1v5.25a1 1 0 1 1-2 0v-5.25a1 1 0 0 1 1-1M4.125 14.375a1 1 0 1 0 0 2h1.807l-2.62 3.669a1 1 0 0 0 .813 1.581h3.75a1 1 0 1 0 0-2H6.068l2.62-3.669a1 1 0 0 0-.813-1.581z"
  }))));
};
export default SvgIconFileZip;